import * as API from '@/API'

const createState = () => ({
  person: null,
  personServices: null,

  // eco system company
  companyDetails: null,
  companyServices: null,
  childCompanies: [],
})

const actions = {
  getCompanyUser: async (_, personUid) => {
    try {
      const results = await API.getCompanyUser(personUid)
      return Promise.resolve(results)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getService: async (_, serviceId) => {
    try {
      const results = await API.getService(serviceId)
      return Promise.resolve(results)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getServices: async (_, { serviceIds, configParams = { 'inc-portal': 1 } }) => {
    try {
      const results = await API.getServices(serviceIds, configParams)
      return Promise.resolve(results)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getCompanyById: async (_, companyId) => {
    try {
      const results = await API.getCompanyDetails(companyId)
      return Promise.resolve(results)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getChildCompanies: async (_, companyIds) => {

    const requests = companyIds.map(id => API.getCompanyDetails(id))
    try {
      const res = await Promise.all(requests)
      return Promise.resolve(res)
    } catch (error) {
      return Promise.reject(error)
    }
  },

  getCompanyDetailsAndServices: async ({ commit, dispatch }, companyId) => {
    commit('clearCompanyDetails')
    await dispatch('getCompanyDetails', companyId)
    await dispatch('getCompanyServices', companyId)
    return Promise.resolve()
  },
  getCompanyDetails: async ({ commit }, companyId) => {
    try {
      const results = await API.getCompanyDetails(companyId)
      commit('setNodeValue', {
        key: 'companyDetails',
        value: results,
      })
      return Promise.resolve()
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getCompanyServices: async ({ commit }, companyId) => {
    try {
      const results = await API.getCompanyServices(companyId)
      commit('setNodeValue', {
        key: 'companyServices',
        value: results,
      })
      return Promise.resolve()
    } catch (error) {
      return Promise.reject(error)
    }
  },
  findCompanyService: async (_, uuid) => {
    try {
      const results = await API.searchRequest(uuid)
      return Promise.resolve(results)
    } catch (error) {
      return Promise.reject(error)
    }
  },
}

const getters = {}

const mutations = {
  setNodeValue: (state, nodeObject) => {
    state[nodeObject.key] = nodeObject.value
  },
  clearCompanyDetails: state => {
    state.companyDetails = null
  },
}

export default {
  namespaced: true,
  actions,
  getters,
  mutations,
  state: createState(),
}
